// extracted by mini-css-extract-plugin
export var bloc = "actualite-module--bloc--eae27";
export var blocImage = "actualite-module--blocImage--4b7d1";
export var containerDate = "actualite-module--containerDate--c84cb";
export var contentActualite = "actualite-module--contentActualite--c550e";
export var dateBloc = "actualite-module--dateBloc--7f370";
export var dateLabel = "actualite-module--dateLabel--2777d";
export var description = "actualite-module--description--f9be3";
export var h1 = "actualite-module--h1--88648";
export var h2 = "actualite-module--h2--fc0f4";
export var h3Title = "actualite-module--h3Title--4b039";
export var hover = "actualite-module--hover--9b681";
export var hovered = "actualite-module--hovered--67f1d";
export var imgWrapper = "actualite-module--imgWrapper--77b34";
export var innerBloc = "actualite-module--innerBloc--d28f9";
export var logo = "actualite-module--logo--a23ec";
export var margin = "actualite-module--margin--6ed06";
export var nbLines = "actualite-module--nbLines--61d2d";
export var subTitle = "actualite-module--subTitle--84a5a";
export var title = "actualite-module--title--30da1";